
import config from './config';

export default config;



// WEBPACK FOOTER //
// ./src/modules/config/index.js